/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Status_Message_HintInputs */



/**
* | output |
* | --- |
* | "Leave a language empty to show the default message for it." |
*
* @param {Partner_Status_Message_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_status_message_hint = /** @type {((inputs?: Partner_Status_Message_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Status_Message_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Lassen Sie eine Sprache leer, um dafür die Standardnachricht anzuzeigen.")
	return /** @type {LocalizedString} */ ("Leave a language empty to show the default message for it.")
});